import {Injectable} from "@angular/core";
import {Headers, Http} from "@angular/http";

import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs/Rx";

import {Plan} from "./plan";

import myGlobals = require("../config");

@Injectable()
export class PlanService {
    private planUrl = myGlobals.default.BASE_URL + "/plan/"; // URL to web api

    constructor(private http: Http) {}

    //Obtener todos los planes habilitados para el usuario
    getPlanes() {
        return this.http.get(this.planUrl).map((response) => response.json());
    }

    //Obtener un plan
    getPlan(_id: string): Observable<Plan> {
        return this.http
            .get(this.planUrl + _id)
            .map((response) => response.json());
    }

    save(plan: Plan): Observable<Plan> {
        if (plan._id) {
            return this.put(plan);
        }
        //Seteo estado activo
        plan.estado = true;
        return this.post(plan);
    }

    //Desactivar plan
    delete(plan: Plan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let url = `${this.planUrl}/${plan._id}`;

        return this.http
            .delete(url, {headers: headers})
            .map((response) => response.json());
    }

    // Agregar nuevo plan
    private post(plan: Plan): Observable<Plan> {
        let headers = new Headers({
            "Content-Type": "application/json;charset=UTF-8",
        });
        headers.append("dataType", "json");
        console.log(plan);
        console.log(JSON.stringify(plan));
        var planStr = JSON.stringify(plan);
        return this.http
            .post(this.planUrl, planStr, {headers: headers})
            .map((response) => response.json());
    }

    // Actualizar plan
    private put(plan: Plan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let url = `${this.planUrl}/${plan._id}`;

        return this.http
            .put(url, JSON.stringify(plan), {headers: headers})
            .map((response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/plan/plan.service.ts